export default __webpack_public_path__ + "static/media/blank_quiz_invitation.07761959.svg";